"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _GenericPaymentWorkflowComponent = _interopRequireDefault(require("./GenericPaymentWorkflowComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  return {
    depositInfo: state.deposit.depositInfo.reverse(),
    templateType: state.deposit.templateType
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps)(_GenericPaymentWorkflowComponent["default"]);